export default __webpack_public_path__ + "static/media/ico-transaction.f121ac55.png";